<script>
import { dataToFormData } from '@/utils/helpers'
import { rexText } from '@/components/views/rexField'
import cameraIcon from '@/assets/images/icons/camera.svg?inline'

export default {
  name: 'UserForm',
  components: {
    rexText,
    cameraIcon
  },
  data: () => ({
    file: null
  }),
  computed: {
    userProfile() {
      return this.$store.getters['profile/getUserProfile']
    },
    userFormIsShown() {
      return this.$store.getters['myAgency/showUserForm']
    },
    userForm() {
      return this.$store.getters['myAgency/getUserForm']
    }
  },
  methods: {
    hideUserForm() {
      this.$store.commit('myAgency/changeShowUserForm', false)
    },
    submitUserForm(data) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('profile/updateUserProfile', this.userForm)
        }
      })
    },
    submitUserAvatar(file) {
      this.$store.commit('profile/setUserProfile', {
        image: window.URL.createObjectURL(file)
      })
      this.$store.dispatch('profile/updateUserAvatar', dataToFormData({
        image: file
      }))
    }
  }
}
</script>

<template>
  <div class="my-agency__content">
    <div class="my-agency__user-form">
      <form @submit.prevent="submitUserForm">
        <div class="my-agency__user-form-row">
          <div class="my-agency__user-form-avatar">
            <b-field class="file">
              <b-upload
                v-model="file"
                accept="image/jpeg,image/png"
                @input="submitUserAvatar"
              >
                <div class="my-agency__user-form-avatar-wp">
                  <img
                    v-if="userProfile.image"
                    :src="userProfile.image"
                    alt=""
                  >
                  <img
                    v-else
                    src="@/assets/images/default.jpg"
                    alt=""
                  >
                  <div class="my-agency__user-form-avatar-overlay">
                    <cameraIcon />
                  </div>
                </div>
              </b-upload>
            </b-field>
          </div>
          <div class="my-agency__user-form-column">
            <rex-text
              label="Полное имя"
              name="fullname"
              store-module="myAgency"
              getter-name="getField"
              setter-name="updateField"
              target="userForm.fullname"
            />
            <rex-text
              label="Телефон"
              name="phone"
              store-module="myAgency"
              getter-name="getField"
              setter-name="updateField"
              target="userForm.phone"
              :validate="{
                required: true
              }"
            />
            <rex-text
              label="E-mail"
              name="email"
              store-module="myAgency"
              getter-name="getField"
              setter-name="updateField"
              target="userForm.email"
              :validate="{
                required: true
              }"
            />
          </div>
          <div class="my-agency__user-form-save">
            <button
              class="my-agency__btn rex-btn rex-btn--bold"
            >
              <span>Сохранить</span>
            </button>
            <a
              href="javascript:;"
              class="my-agency__btn rex-btn rex-btn--bold rex-btn--gray"
              @click="hideUserForm"
            >
              <span>Закрыть без изменений</span>
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>